// extracted by mini-css-extract-plugin
export var externalLink = "_88-0";
export var internalLinkLabel = "_88-1";